<template>
 
  <ModalDetalleEjecucionPresupuestaria :borrador="borrador" :visible="visibleModal" @update:visible="visibleModal = $event"
    :centro_responsable_cuentas="solo_centro_responsable_cuentas" :selectedCategoria="selectedCategoria"
    :selectedCuenta="selectedCuenta" />



  <div class="flex justify-between">
    <span
      class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">&lt;ReporteriaPresupuestos&gt;</span>
    <span
      class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">/api/v1/presupuesto/todoscentros/</span>
  </div>
 
  <!-- totales budget categoria (clasificacion)-->
  <div class="rounded-lg border-4 border-gray-300">
    <div class="flex items-center justify-between   px-4 py-3 cursor-pointer"
    :class="borrador
          ? 'bg-gradient-to-r from-green-800 to-emerald-200 text-white'
          : 'bg-gradient-to-r from-indigo-800 to-blue-200 text-white'"
      @click="colapsado1 = !colapsado1">
      <span class="font-semibold text-lg font-mono"> Suma totales de todos los centros asignados {{ aa_consulta }} </span>

      <svg
        class="w-8 h-8 p-1 rounded-full bg-indigo-600 text-white hover:bg-indigo-700 cursor-pointer transition-transform"
        :class="{ 'rotate-180': !colapsado1 }" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
      </svg>

    </div>
    <!-- CONTENIDO -->
    <div v-show="!colapsado1" class="overflow-x-auto pt-6 pb-6  ">
      <div v-if="loading" class="w-6 h-6 mx-auto border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin">
      </div>
      <!-- Tabla -->
      <div class="overflow-x-auto flex justify-center items-center">
        
      <ReporteriaTablaTotales :capitalInvestment="false" :borrador="borrador"/>
      </div>

       <!-- Tabla -->
      <div class="overflow-x-auto flex justify-center items-center">
        
      <ReporteriaTablaTotales :capitalInvestment="true" :borrador="borrador"/>
      </div>
    </div>
  </div>




  <!-- desglose budget categoria (clasificacion) y agrupado por territorio-->
  <div class="rounded-lg border-4 border-gray-300 mt-2">


    <div class="flex items-center justify-between   px-4 py-3 cursor-pointer"
    :class="borrador
          ? 'bg-gradient-to-r from-green-800 to-emerald-200 text-white'
          : 'bg-gradient-to-r from-indigo-800 to-blue-200 text-white'"
      @click="colapsado2 = !colapsado2">
      <span class="font-semibold text-lg font-mono">
        Detalle centros ordenados por territorio  {{ aa_consulta }}
      </span>

      <!-- icono -->
      <svg
        class="w-8 h-8 p-1 rounded-full bg-indigo-600 text-white hover:bg-indigo-700 cursor-pointer transition-transform"
        :class="{ 'rotate-180': !colapsado2 }" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    </div>
    <LeyendaColoresClasificacionCentro @click="colapsado2 = !colapsado2" :colores="colores" :leyenda="leyenda"
      style="cursor: pointer;" />
    <div v-show="!colapsado2" class="overflow-x-auto pt-6 pb-6  px-0">

      <div v-if="loading2" class="w-6 h-6 mx-auto border-4 border-pink-300 border-t-pink-600 rounded-full animate-spin">
      </div>

      <div class="flex justify-start ">
        <span
          class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">&#60;array_presupuesto_categorias
          + centros &#62;</span>
      </div>
      <table class="w-full text-sm text-gray-700 border-collapse">

        <!-- THEAD -->
        <thead class="bg-gray-200 text-gray-700 uppercase text-xs tracking-wide">
          <tr>
            <!-- COLUMNA STICKY -->
            <th class="sticky left-0 z-20
                   bg-gray-200
                   border border-gray-300
                   px-4 py-3 text-left text-xs font-mono">
              Categoría
            </th>
            <th class="   bg-gray-200
                   border border-gray-300
                   px-4 py-3 text-left  text-xs font-mono">
              Budget {{ año }}
            </th>
            <th v-for="(cc, index) in centros" :key="index"
              class="border border-gray-300 px-4 py-3 text-center  text-xs font-mono"
              :style="{ backgroundColor: colores[cc.clasificacioncentro_id - 1] }">
              <div class="flex flex-col min-h-[100px] min-w-[130px] p-3 justify-between">
                <!-- MONTO -->

                <div class="  text-gray-500"> <span class="text-xs font-mono">{{ cc.user?.first_name }} {{
                  cc.user?.last_name }} </span> </div>
                <div class="text-sm font-semibold text-gray-900 font-mono  ">
                  {{ cc.nombre }}
                </div>

              </div>
            </th>
          </tr>
        </thead>

        <!-- TBODY -->
        <tbody>
          <tr v-for="(categoria, index) in array_presupuesto_categorias" :key="index"
            class="hover:bg-gray-50 transition">

            <!-- PRIMERA COLUMNA STICKY -->
            <td class="sticky left-0 z-10 bg-white border border-gray-300 px-4 py-3  text-xs  font-mono">
              {{ categoria.nombre }}
            </td>
            <td class=" border border-gray-300 px-6 py-3  font-semibold text-gray-900 font-mono">
              <!-- total presupuesto -->
              {{ $formatoMiles(presupIndexCategorias[`${categoria.id}`] || 0) }}
            </td>
            <!-- COLUMNAS DINÁMICAS -->
            <td @click="detalle(centro.id, categoria.id)" v-for="(centro, i) in centros" :key="i"
              class="border border-gray-300   px-5 py-3  cursor-pointer"
              :class="{ 'bg-yellow-300': celda_seleccionada === `${centro.id}-${categoria.id}` }"
              :style="{ backgroundColor: celda_seleccionada === `${centro.id}-${categoria.id}` ? '' : colores[centro.clasificacioncentro_id - 1] }">


              <div class="flex flex-col gap-1">

                <!-- MONTO -->
                <div class="text-sm font-semibold text-gray-900 font-mono  ">
                  {{ $formatoMiles(presupIndex.presupuesto[`${centro.id}-${categoria.id}`] || 0) }}
                </div>

                <!-- PORCENTAJE -->
                <div class="text-xs text-gray-600">
                  {{ $formatoNumero(presupIndex.ejecucion[`${centro.id}-${categoria.id}`] || 0) }} %
                </div>

                <!-- BARRA DE PROGRESO -->
                <div class="w-full bg-gray-200 rounded h-1.5 overflow-hidden">
                  <div class="h-1.5 rounded transition-all" :class="{
                    'bg-green-500': presupIndex.ejecucion[`${centro.id}-${categoria.id}`] <= 70,
                    'bg-yellow-500': presupIndex.ejecucion[`${centro.id}-${categoria.id}`] > 70 && presupIndex.ejecucion[`${centro.id}-${categoria.id}`] < 100,
                    'bg-red-600': presupIndex.ejecucion[`${centro.id}-${categoria.id}`] >= 100
                  }" :style="{
                    width: Math.min(presupIndex.ejecucion[`${centro.id}-${categoria.id}`] || 0, 100) + '%'
                  }"></div>
                </div>

              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td></td>
            <td class="border border-gray-300   px-0 py-3 font-semibold text-gray-900 font-mono   ">
              $ {{ $formatoMiles(totIndexCategorias.total_presupuesto || 0) }}
            </td>
            <td v-for="(centro, i) in centros" :key="i" class="border border-gray-300   px-5 py-3  cursor-pointer">
              <div class="flex flex-col  ">
                <!-- MONTO -->

                <div class="text-sm font-semibold text-gray-900 font-mono  ">
                  $ {{ $formatoMiles(totPresupIndex.presupuesto[`${centro.id}`] || 0) }}
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>

    </div>


    <div v-show="!colapsado2" class="overflow-x-auto pt-6 pb-6  ">


      <div class="  overflow-x-auto rounded-lg   border border-gray-300 pt-6 pb-6">

        <h3 class="font-mono text-lg"> {{ objCentroSeleccionado.nombre }} {{ responsable_firstname }} {{
          responsable_lastname }} </h3>

        <div v-for="categoria in this.categoriasCuentas" :key="categoria.id" class="  rounded-lg  p-3 mt-3">
          <h2 class="  text-gray-700 mb-2 font-mono">
            {{ categoria.nombre }}
          </h2>

          <!-- Nivel 2: Tipos -->
          <div v-for="tipo in categoria.tipos" :key="tipo.id" class="mt-4">

            <h3 class="text-md  text-blue-700 mb-1 font-mono">{{ tipo.nombre }}</h3>

            <!-- Nivel 3: Cuentas -->
            <div v-for="cuenta in tipo.cuentas" :key="cuenta.id" class="ml-5 ">


              <CuentaPresupuestosSoloLectura :propCuenta="cuenta" :propCentro="objCentroSeleccionado"
                :cuentaExpandida="cuentaExpandida" @toggleCuenta="toggleCuenta" @reloadTotPresup="reloadTotPresup" />




            </div>
          </div>
        </div>






      </div>
    </div>



  </div>
  <!-- desglose budget catetoria y agrupado por  responsable -->
  <div v-if="this.superUser" class="rounded-lg border-4 border-gray-300 mt-2">
    <div class="flex items-center justify-between  px-4 py-3 cursor-pointer" 
    :class="borrador
          ? 'bg-gradient-to-r from-green-800 to-emerald-200 text-white'
          : 'bg-gradient-to-r from-indigo-800 to-blue-200 text-white'"
      @click="colapsado3 = !colapsado3">
      <span class="font-semibold text-lg font-mono"> Detalle centros ordenado por responsable   {{ aa_consulta }} </span>
      <svg
        class="w-8 h-8 p-1 rounded-full bg-indigo-600 text-white hover:bg-indigo-700 cursor-pointer transition-transform"
        :class="{ 'rotate-180': !colapsado3 }" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
      </svg>

    </div>
    <LeyendaColoresClasificacionCentro @click="colapsado3 = !colapsado3" :colores="colores" :leyenda="leyenda"
      style="cursor: pointer;" />
    <!-- CONTENIDO -->
    <div v-show="!colapsado3" class="overflow-x-auto pt-6 pb-6  ">
      <!-- Tabla -->
      <div class="overflow-x-auto">

        <div class="flex justify-start ">
          <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">
            &#60;array_presupuesto_categorias + centros_responsables&#62;</span>
        </div>
        <div v-if="loading"
          class="w-6 h-6 mx-auto border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>

        <table class="w-full text-sm text-gray-700 border-collapse">
          <!-- THEAD -->
          <thead class="bg-gray-200 text-gray-700 uppercase text-xs tracking-wide">
            <tr>
              <!-- COLUMNA STICKY -->
              <th class="sticky left-0 z-20
                   bg-gray-200
                   border border-gray-300
                   px-4 py-3 text-left text-xs font-mono">
                Categoría
              </th>
              <th class="   bg-gray-200
                   border border-gray-300
                   px-4 py-3 text-left  text-xs font-mono">
                Budget {{ año }}
              </th>
              <th v-for="(cc, index) in centros_responsables" :key="index"
                class="border border-gray-300 text-center  text-xs font-mono"
                :style="{ backgroundColor: colores[cc.clasificacioncentro_id - 1] }">
                <div class="flex flex-col min-h-[100px]  w-[150px] p-3 justify-between">

                  <div class="  text-gray-500"> <span class="text-xs font-mono">{{ cc.user?.first_name }} {{
                    cc.user?.last_name }} </span> </div>
                  <div class="text-sm font-semibold text-gray-900 font-mono  ">
                    {{ cc.nombre }}
                  </div>
                </div>
              </th>
            </tr>
          </thead>

          <!-- TBODY -->
          <tbody>
            <tr v-for="(categoria, index) in array_presupuesto_categorias" :key="index"
              class="hover:bg-gray-50 transition">

              <!-- PRIMERA COLUMNA STICKY -->
              <td class="sticky left-0 z-10 bg-white border border-gray-300 px-4 py-3  text-xs  font-mono">
                {{ categoria.nombre }}
              </td>
              <td class=" border border-gray-300 px-6  py-3  font-semibold text-gray-900 font-mono   ">
                <!-- total presupuesto -->
                {{ $formatoMiles(presupIndexCategorias[`${categoria.id}`] || 0) }}
              </td>
              <!-- COLUMNAS DINÁMICAS -->
              <td @click="detalle(centro.id, categoria.id)" v-for="(centro, i) in centros_responsables" :key="i"
                class="border border-gray-300   px-5 py-3  cursor-pointer"
                :class="{ 'bg-yellow-300': celda_seleccionada === `${centro.id}-${categoria.id}` }"
                :style="{ backgroundColor: celda_seleccionada === `${centro.id}-${categoria.id}` ? '' : colores[centro.clasificacioncentro_id - 1] }">


                <div class="flex flex-col gap-1">

                  <!-- MONTO -->
                  <div class="text-sm font-semibold text-gray-900 font-mono  ">

                    {{ $formatoMiles(presupIndex.presupuesto[`${centro.id}-${categoria.id}`] || 0) }}
                  </div>

                  <!-- PORCENTAJE -->
                  <div class="text-xs text-gray-600">
                    {{ $formatoNumero(presupIndex.ejecucion[`${centro.id}-${categoria.id}`] || 0) }} %
                  </div>

                  <!-- BARRA DE PROGRESO -->
                  <div class="w-full bg-gray-200 rounded h-1.5 overflow-hidden">
                    <div class="h-1.5 rounded transition-all" :class="{
                      'bg-green-500': presupIndex.ejecucion[`${centro.id}-${categoria.id}`] <= 70,
                      'bg-yellow-500': presupIndex.ejecucion[`${centro.id}-${categoria.id}`] > 70 && presupIndex.ejecucion[`${centro.id}-${categoria.id}`] < 100,
                      'bg-red-600': presupIndex.ejecucion[`${centro.id}-${categoria.id}`] >= 100
                    }" :style="{
                      width: Math.min(presupIndex.ejecucion[`${centro.id}-${categoria.id}`] || 0, 100) + '%'
                    }"></div>
                  </div>

                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td></td>
              <td class="border border-gray-300   px-0 py-3 font-semibold text-gray-900 font-mono   ">
                $ {{ $formatoMiles(totIndexCategorias.total_presupuesto || 0) }}
              </td>
              <td v-for="(centro, i) in centros_responsables" :key="i" class="border border-gray-300   px-5 py-3  ">
                <div class="flex flex-col  ">
                  <!-- MONTO -->

                  <div class="text-sm font-semibold text-gray-900 font-mono  ">
                    $ {{ $formatoMiles(totPresupIndex.presupuesto[`${centro.id}`] || 0) }}
                  </div>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>


      </div>

      <div v-show="!colapsado3" class="overflow-x-auto pt-6 pb-6  ">
        <div class="  overflow-x-auto rounded-lg   border border-gray-300 pt-6 pb-6">

          <h3 class="font-mono text-lg"> {{ objCentroSeleccionado.nombre }} / {{ responsable_firstname }} {{
            responsable_lastname }} </h3>

          <div v-for="categoria in this.categoriasCuentas" :key="categoria.id" class="  rounded-lg  p-3 mt-3">
            <h2 class="  text-gray-700 mb-2 font-mono">
              {{ categoria.nombre }}
            </h2>

            <!-- Nivel 2: Tipos -->
            <div v-for="tipo in categoria.tipos" :key="tipo.id" class="mt-4">

              <h3 class="text-md  text-blue-700 mb-1 font-mono">{{ tipo.nombre }}</h3>

              <!-- Nivel 3: Cuentas -->
              <div v-for="cuenta in tipo.cuentas" :key="cuenta.id" class="ml-5 ">


                <CuentaPresupuestosSoloLectura :borrador="borrador" :propCuenta="cuenta" :propCentro="objCentroSeleccionado"
                  :cuentaExpandida="cuentaExpandida" @toggleCuenta="toggleCuenta" @reloadTotPresup="reloadTotPresup" />




              </div>
            </div>
          </div>
          <!-- <CentroCuentasMayorCero   v-if="prop_obj_centro" }
   :prop_obj_centro="prop_obj_centro" 
   :prop_categoria_id="prop_categoria_id"
   :prop_solo_lectura="solo_lectura" />-->





        </div>
      </div>
    </div>

  </div>
  <!-- exportar a pdf consolidado -->
  <div > 
  <div v-if="borrador==false && (this.superUser || this.userEsCeciliaBrahm)" class="rounded-lg border-4 border-gray-300 mt-2">
    <div class="flex items-center justify-between   px-4 py-3 cursor-pointer"
    :class="borrador
          ? 'bg-gradient-to-r from-green-800 to-emerald-200 text-white'
          : 'bg-gradient-to-r from-indigo-800 to-blue-200 text-white'"
      @click="colapsado4 = !colapsado4">
      <span class="font-semibold text-lg font-mono"> Ejecución Presupuestaria {{ año }} </span>
      <svg
        class="w-8 h-8 p-1 rounded-full bg-indigo-600 text-white hover:bg-indigo-700 cursor-pointer transition-transform"
        :class="{ 'rotate-180': !colapsado4 }" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
      </svg>

    </div>
    <!-- CONTENIDO -->
    <div v-show="!colapsado4" class="overflow-x-auto pt-6 pb-6  ">


      <div v-show="!colapsado4" class="overflow-x-auto pt-6 pb-6  ">
        <div class="  overflow-x-auto rounded-lg   border border-gray-300 p-6 m-6 font-mono">

          <div v-if="loading_responsables"
            class="w-6 h-6 mx-auto border-4 border-pink-300 border-t-pink-600 rounded-full animate-spin"></div>

          <div v-else>


            <div class="bg-white border border-gray-200 rounded-2xl shadow-sm p-5 space-y-3">

              <!-- Responsable -->
              <div class="grid grid-cols-[140px_1fr] items-center gap-3">
                <label for="user" class="text-sm font-medium text-gray-700">
                  Responsable
                </label>

                <select id="user" name="user" v-model="selectedUserId" class="w-full px-3 py-2 border border-gray-300 rounded-lg
             bg-white text-sm shadow-sm
             focus:ring-2 focus:ring-indigo-300 outline-none">
                  <option value="0">Todos</option>
                  <option v-for="user in users_unicos" :key="user.id" :value="user.id">
                    {{ user.first_name }} {{ user.last_name }}
                  </option>
                </select>
              </div>

              <!-- Territorio -->
              <div class="grid grid-cols-[140px_1fr] items-center gap-3">
                <label for="clasificacioncentro" class="text-sm font-medium text-gray-700">
                  Territorio
                </label>

                <select id="clasificacioncentro" name="clasificacioncentro" v-model="selectedClasificacionCentro" class="w-full px-3 py-2 border border-gray-300 rounded-lg
             bg-white text-sm shadow-sm
             focus:ring-2 focus:ring-indigo-300 outline-none">
                  <option value="0">Todos</option>
                  <option v-for="clasif in clasificacionesUsuario" :key="clasif.id" :value="clasif.id">
                    {{ clasif.nombre }}
                  </option>
                </select>
              </div>

              <!-- Centro -->
              <div class="grid grid-cols-[140px_1fr] items-center gap-3">
                <label for="centro" class="text-sm font-medium text-gray-700">
                  Centro de costo
                </label>

                <select id="centro" name="centro" v-model="selectedCentro" class="w-full px-3 py-2 border border-gray-300 rounded-lg
             bg-white text-sm shadow-sm
             focus:ring-2 focus:ring-indigo-300 outline-none">
                  <option value="0">Todos</option>
                  <option v-for="centro in centrosUsuarios" :key="centro.id" :value="centro.id">
                    {{ centro.nombre }}
                  </option>
                </select>
              </div>
              <!-- Categoria cuenta -->
              <div class="grid grid-cols-[140px_1fr] items-center gap-3">
                <label for="categoria" class="text-sm font-medium text-gray-700">
                  Categoria
                </label>

                <select id="categoria" name="categoria" v-model="selectedCategoria" class="w-full px-3 py-2 border border-gray-300 rounded-lg
             bg-white text-sm shadow-sm
             focus:ring-2 focus:ring-indigo-300 outline-none">
                  <option value="0">Todas</option>
                  <option v-for="categorias in categoriasUsuario" :key="categorias.id" :value="categorias.id">
                    {{ categorias.nombre }}
                  </option>
                </select>

              </div>
              <!-- tipos cuenta -->
              <div class="grid grid-cols-[140px_1fr] items-center gap-3">

                <label for="tipo" class="text-sm font-medium text-gray-700">
                  Tipo
                </label>

                <select id="tipo" name="tipo" v-model="selectedTipo" class="w-full px-3 py-2 border border-gray-300 rounded-lg
             bg-white text-sm shadow-sm
             focus:ring-2 focus:ring-indigo-300 outline-none">
                  <option value="0">Todos</option>
                  <option v-for="tipos in tiposCtaUsuario" :key="tipos.id" :value="tipos.id">
                    {{ tipos.nombre }}
                  </option>
                </select>

              </div>
              <!--  cuenta -->
              <div class="grid grid-cols-[140px_1fr] items-center gap-3">
                <label for="cuenta" class="text-sm font-medium text-gray-700">
                  Cuenta
                </label>

                <select id="cuenta" name="cuenta" v-model="selectedCuenta" class="w-full px-3 py-2 border border-gray-300 rounded-lg
             bg-white text-sm shadow-sm
             focus:ring-2 focus:ring-indigo-300 outline-none">
                  <option value="0">Todas</option>
                  <option v-for="cuentas in cuentasUsuario" :key="cuentas.id" :value="cuentas.id">
                    {{ cuentas.nombre }} / {{ cuentas.cod }}
                  </option>
                </select>

              </div>
            </div>

            <button @click="resetFiltros()"
              class="mt-3 px-6 py-2 rounded-lg transition font-medium bg-gray-600 hover:bg-gray-700 text-white shadow-md ml-2">
              Reset</button>
            <button @click="abreModal()"
              class="mt-3 px-6 py-2 rounded-lg transition font-medium bg-blue-600 hover:bg-blue-700 text-white shadow-md ml-2">
              Buscar </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</div> 


 
</template>
<script>

import api from "@/api/axios";
import { useCatPresup } from "@/composables/useCatPresup";
 

import CuentaPresupuestosSoloLectura from "./CuentaPresupuestosSoloLectura.vue";

import LeyendaColoresClasificacionCentro from "./LeyendaColoresClasificacionCentro.vue"
import ModalDetalleEjecucionPresupuestaria from "./ModalDetalleEjecucionPresupuestaria.vue";
import ReporteriaTablaTotales from "./ReporteriaTablaTotales.vue";
export default {
  name: 'ReporteriaPresupuestos',
  props:{
    borrador:{
      type:Boolean
    }  
  },
  computed: {
    presupIndex() {
      const mapa = {}
      const mapa2 = {}

      this.presup_ctas.forEach(p => {
        const key = `${p.centro_id}-${p.categoria_id}`
        mapa[key] = p.total_presupuesto

        if (p.total_presupuesto > 0) {
          mapa2[key] = p.total_gastos * 100 / p.total_presupuesto
        } else {
          if (p.total_gastos > 0) {
            mapa2[key] = "100"
          }
        }

      })

      return { presupuesto: mapa, ejecucion: mapa2 }
    },

    presupIndexCategorias() {
      const mapa = {}

      this.array_presupuesto_categorias.forEach(p => {
        const key = `${p.id}`
        mapa[key] = p.total_presupuesto
      })

      return mapa
    },
    totIndexCategorias() {
      let mapa = 0


   
      /**
       * [
{
   "id": 1,
   "nombre": "GASTOS DEL PERSONAL",
   "orden": 1,
   "total_gastos": 546997585,
   "total_presupuesto": 2332152398.2
},
{
   "id": 2,
   "nombre": "HONORARIOS",
   "orden": 2,
   "total_gastos": 88913071,
   "total_presupuesto": 529550760
} 
]
       */
      this.array_presupuesto_categorias.forEach(p => {
        mapa += p.total_presupuesto
      })


      return { total_presupuesto: mapa }
    },

    totPresupIndex() {
      const mapa = {}
      const mapa2 = {}

      // this.presup_ctas = [{ "categoria_id": 8, "centro_id": 29, "total_presupuesto": 6800000, "total_gastos": 0 },] 
      // reccorre y suma total  
      this.presup_ctas.forEach(p => {
        const key = `${p.centro_id}`
        if (mapa[key] == null) {
          mapa[key] = 0;
        }
        mapa[key] += p.total_presupuesto
      })


      return { presupuesto: mapa, ejecucion: mapa2 }
    },

    tot_tabla1() {
      return this.array_presupuesto_categorias.reduce(
        (acc, item) => {
          acc.presupuestos += Number(item.total_presupuesto || 0);
          acc.gastos += Number(item.total_gastos || 0);

          return acc;
        },
        { presupuestos: 0, gastos: 0 }
      );
    },

    mesesDisponibles() {
      const mesActual = new Date().getMonth() + 1
      return Array.from({ length: mesActual }, (_, i) => i + 1)
    },

    clasificacionesUsuario() {
      const usuario = this.clasificacion_unicos.find(
        item => item.user_id === this.selectedUserId
      );

      if (!usuario) return [];

      return usuario.clasificacioncentro_id.map(id => ({ id, nombre: this.nombreclasificacion[id] }));

    },
    centrosUsuarios() {
      if (!this.selectedClasificacionCentro) {
        return [];
      }
      const mapa = new Map();

      this.centros_responsables
        .filter(
          centro =>
            centro.clasificacioncentro_id === this.selectedClasificacionCentro &&
            centro.user.id === this.selectedUserId
        )
        .forEach(centro => {
          mapa.set(centro.id, {
            id: centro.id,
            nombre: centro.nombre
          });
        });

      return Array.from(mapa.values());
    },
    categoriasUsuario() {
      const categoriasUsuario = this.categorias.map(cat => ({
        id: cat.id,
        nombre: cat.nombre
      }))
      return categoriasUsuario
    },
    tiposCtaUsuario() {
      if (!this.selectedCategoria) {
        return [];
      }

      // método map() se usa en arreglos (arrays) y crea un nuevo arreglo aplicando una función a cada elemento del arreglo original. No modifica el arreglo original.
      const tipos = this.categorias
        .find(cat => cat.id === this.selectedCategoria)
        ?.tipos.map(tipo => ({
          id: tipo.id,
          nombre: tipo.nombre
        })) || [];
      return tipos;
    },

    cuentasUsuario() {
      let cuentas = [];

      if (this.selectedCategoria == 0 && this.selectedTipo == 0) {
        cuentas = this.categorias.flatMap(categoria =>
          categoria.tipos.flatMap(tipo =>
            tipo.cuentas.map(cuenta => ({
              id: cuenta.id,
              nombre: cuenta.nomcta,
              cod: cuenta.cod
            }))
          )
        );
      } else {
        if (this.selectedCategoria > 0 && this.selectedTipo == 0) {
          cuentas = this.categorias.find(cat => cat.id === this.selectedCategoria)
            ?.tipos.flatMap(tipo =>

              tipo.cuentas.map(cuenta => ({
                id: cuenta.id,
                nombre: cuenta.nomcta,
                cod: cuenta.cod
              }))
            ) || [];

        } else {
          if (this.selectedCategoria > 0 && this.selectedTipo > 0) {
            cuentas =
              this.categorias.find(cat => cat.id === this.selectedCategoria)
                ?.tipos.find(tipo => tipo.id === this.selectedTipo)
                ?.cuentas.map(cuenta => ({
                  id: cuenta.id,
                  nombre: cuenta.nomcta,
                  cod: cuenta.cod
                })) || [];

          }
        }
      }




      cuentas.sort((a, b) => a.nombre.localeCompare(b.nombre));

      return cuentas;

    },


    
    centrosConPresupuesto() {
      return this.det.centros.filter(c => parseFloat(c.total_presupuestos) > 0).length
    },
    centrosSinPresupuesto() {
      return this.det.centros.filter(c => parseFloat(c.total_presupuestos) === 0).length
    },
  
  },


  components: {
    CuentaPresupuestosSoloLectura,
    LeyendaColoresClasificacionCentro,
    ModalDetalleEjecucionPresupuestaria,
    ReporteriaTablaTotales
  },
  mounted() {



    this.superUser = this.$store.state.auth.userLogin.modifica_presupuestos;
    this.user_id = this.$store.state.auth.userLogin.id;
    if (this.user_id == 6) {
      this.userEsCeciliaBrahm = true
    }
    this.inicializar()
    this.loadCentros()
    this.categoriasAgrupadas()
  },
  methods: {
     inicializar(){
        this.aa_consulta =  this.$store.state.auth.userLogin.año  
        if (this.borrador)
        {
            this.aa_consulta = this.$store.state.auth.userLogin.año_borrador
        }
    },
 
 
    loadCentros() {
       
      const cc = this.$store.state.centros.centros
      // filtra solo C.C con RESPONSABLE asignado
      this.centros = cc.filter(c => c.usuarios && c.usuarios.length > 0);

      let autorizado = false
      if (this.superUser) {
        autorizado = true
      } else {
        if (this.userEsCeciliaBrahm) {
          autorizado = true;
        }
      }



      if (!autorizado) {
        /**
         *this.centros {
                "id": 60,
                "codigo": "PMA056000000000",
                "nombre": "Megatransecto",
                "tiene_presupuesto": true,
                "clasificacioncentro_id": 1,
                "user": {
                    "id": 11,
                    "first_name": "Mathias",
                    "last_name": "HÜNE"
                },
                "usuarios": [
                    {
                        "id": 11,
                        "first_name": "Mathias",
                        "last_name": "HÜNE"
                    },
                    {
                        "id": 6,
                        "first_name": "Cecilia",
                        "last_name": "Brahm"
                    },
                  
                    {
                        "id": 18,
                        "first_name": "OscaR",
                        "last_name": "Aguilera"
                    }
                ]
            }
         */
        this.centros.sort((a, b) => {
          const ua = a.clasificacioncentro_id ?? Infinity;
          const ub = b.clasificacioncentro_id ?? Infinity;
          return ua - ub;
        });


      } else {

        // solo para Super-Usuarios: listado de centros agrupado por usuario

        this.centros_responsables = []
        this.centros_responsables = cc.filter(c => c.user?.id > 0);

        this.centros_responsables.sort((a, b) => {
          const ua = a.user?.id ?? Infinity;
          const ub = b.user?.id ?? Infinity;
          return ua - ub;
        });



        // ordena por clasificacioncentro y orden
        this.centros.sort(
          (a, b) =>
            a.clasificacioncentro_id - b.clasificacioncentro_id ||
            a.orden - b.orden ||
            a.user.id - b.user.id
        )

      }


    },
    async categoriasAgrupadas() {

      // recupera cuentas con presupuestos ingresados
      this.loading = true;
      this.loading2 = true;
      this.loading_responsables = true;
      let presupuestos;
      try {
        let autorizado = false;
        let data = {}

        if (this.superUser) {
          autorizado = true
        } else {
          if (this.userEsCeciliaBrahm) {
            autorizado = true;
          }
        }


        if (!autorizado) {
          data = {
            user_id: this.user_id
          }
        }

        if(this.borrador){
          data['borrador']="True"
        }
        // trae presupuestos con o sin movimiento
        const response = await api.post("api/v1/presupuesto/todoscentros/", data, {
          headers: {
            "Content-Type": "application/json",

          },
        });

        if (response.status === 200) {





          this.año = response.data.año;
          presupuestos = response.data.presupuestos;

         
         
          /*          
  array_detalle_centros_año_actual  [
    {
        "categoria_id": 1,
        "centros": [
            {
                "centro_id": 7,
                "total_presupuestos": "0"
            },
            {
                "centro_id": 8,
                "total_presupuestos": "131508027.6"
            },
            {
                "centro_id": 9,
                "total_presupuestos": "253446489.2"
            },
            {
                "centro_id": 10,
                "total_presupuestos": "170635060.8"
            },
            {
                "centro_id": 11,
                "total_presupuestos": "154033160"
            },
          
        ]
    },
    {
        "categoria_id": 2,
        "centros": [
            {
                "centro_id": 4,
                "total_presupuestos": "25340000"
            },
            {
                "centro_id": 7,
                "total_presupuestos": "16312000"
            },
            {
                "centro_id": 8,
                "total_presupuestos": "0"
            },
            
        ]
    }
]
           */


          presupuestos.forEach(p => {

            // localizar registro  
            let existeTipo = this.presup_ctas.find(x =>
              x.centro_id === p.centro_id && x.categoria_id === p.categoria_id
            )



            // si registro no está creado
            if (typeof existeTipo == 'undefined') {
              // añadir
              this.presup_ctas.push({
                'categoria_id': p.categoria_id,
                'centro_id': p.centro_id,
                'total_presupuesto': Number(p.total_presupuesto),
                'total_gastos': Number(p.total_gastos)
              })

            } else {
              existeTipo.total_presupuesto += Number(p.total_presupuesto)
              existeTipo.total_gastos += Number(p.total_gastos)
            }

          });



          /* crear un nuevo  'responsables_y_cuentas' y meter dentro contenido de presup_cuentas.  */

          if (this.centros_responsables) {
            this.responsables_y_cuentas = this.centros_responsables.map(centro => {
              return {
                ...centro,
                presup_ctas: this.presup_ctas.filter(cta => cta.centro_id === centro.id)
              }
            })
          }


          /*
            responsables_y_cuentas=
            [
             {
                  "id": 63,
                  "codigo": "VCO060000000000",
                  "nombre": "Comunidades Magallanes",
                  "tiene_presupuesto": true,
                  "clasificacioncentro_id": 2,
                  "user":  
                      {
                          "id": 4,
                          "first_name": "Carolina",
                          "last_name": "Cerda"
                      } 
                       
                  ],  
                   "usuarios": [
                  {
                      "id": 4,
                      "first_name": "Carolina",
                      "last_name": "Cerda"
                  }
                 
              ],
                  "presup_ctas": [
                      {
                          "categoria_id": 1,
                          "centro_id": 63,
                          "total_presupuesto": 0,
                          "total_gastos": 34520
                      },
                      {
                          "categoria_id": 5,
                          "centro_id": 63,
                          "total_presupuesto": 14350000,
                          "total_gastos": 0
                      }
                    ]
                },
             {
              "id": 36,
              "codigo": "VCO058000000000",
              "nombre": "Comunidades Cerro Castillo",
              "tiene_presupuesto": true,
              "clasificacioncentro_id": 3,
              "orden": 0,
              "user": {
                  "id": 4,
                  "first_name": "Carolina",
                  "last_name": "Cerda"
              },
              "usuarios": [
                  {
                      "id": 4,
                      "first_name": "Carolina",
                      "last_name": "Cerda"
                  },
                  {
                      "id": 6,
                      "first_name": "Cecilia",
                      "last_name": "Brahm"
                  }
              ],
              "presup_ctas": [
                  {
                      "categoria_id": 5,
                      "centro_id": 36,
                      "total_presupuesto": 23600000,
                      "total_gastos": 4132220
                  },
                  {
                      "categoria_id": 1,
                      "centro_id": 36,
                      "total_presupuesto": 13932460,
                      "total_gastos": 4788294
                  },
                  {
                      "categoria_id": 3,
                      "centro_id": 36,
                      "total_presupuesto": 4810000,
                      "total_gastos": 864714
                  },
                  {
                      "categoria_id": 4,
                      "centro_id": 36,
                      "total_presupuesto": 2800000,
                      "total_gastos": 888814
                  },
                  {
                      "categoria_id": 2,
                      "centro_id": 36,
                      "total_presupuesto": 43100000,
                      "total_gastos": 6609834
                  },
                  {
                      "categoria_id": 8,
                      "centro_id": 36,
                      "total_presupuesto": 600000,
                      "total_gastos": 71600
                  }
              ]
              }
            ]
          */

          // crear diccionario usando user.id como clave para eliminar duplicados  y devolver solo los usuarios únicos.

          this.users_unicos = [
            ...new Map(
              this.responsables_y_cuentas.map(c => [c.user.id, c.user])
            ).values()
          ]
          this.clasificacion_unicos = this.creaClasificacionesUnicas(this.responsables_y_cuentas);
          this.loading_responsables = false;
          this.loading2 = false


          const cuentas = this.$store.state.cuentas.cuentas;




          const { getCatPresupV2 } = useCatPresup()

          const { categorias  } = getCatPresupV2(presupuestos, cuentas)
          this.categorias = categorias
          this.loading = false;
           

          /*
              this.categorias
             [   {
              "id": 6,
              "nombre": "COMUNICACIONES SATELITALES",
              "tipos": [
                  {
                      "id": 9,
                      "nombre": "COMUNICACIONES SATELITALES",
                      "cuentas": [
                          {
                              "id": 45,
                              "cod": "4510306001",
                              "nomcta": "Comunicaciones Satelitales",
                              "total_presupuesto": 20437000,
                              "total_gastos": 1678862,
                              "saldo": 18758138
                          }
                      ]
                  }
              ],
              "orden": 5
                }]
                  
                 trae todas las cuentas coincidentes (plan de presupuestos v/s presupuestos creados )
                 tengan o no movimientos
                */

          // ordenar por atributo 'orden'
          this.categorias = Object.values(this.categorias).sort((a, b) =>
            (a.orden ?? Infinity) -
            (b.orden ?? Infinity)
          );
          this.array_presupuesto_categorias = this.categorias.map(grupo => ({
            id: grupo.id,
            nombre: grupo.nombre,
            orden: grupo.orden,
            total_gastos: grupo.tipos.flatMap(t => t.cuentas).reduce((acc, c) => acc + Number(c.total_gastos), 0),
            total_presupuesto: grupo.tipos.flatMap(t => t.cuentas).reduce((acc, c) => acc + Number(c.total_presupuesto), 0),

          }));


          /**
          contenido: array_presupuesto_categorias  
           {
            "nombre": "COMUNICACIONES SATELITALES",
            "total_gastos": 1678862,
            "total_presupuesto": 20437000
          }
          ,{
          "nombre": "INVERSIONES",
          "total_gastos": 0,
          "total_presupuesto": 0
          }
           */

        }


      } catch (e) {
        console.error("Credenciales inválidas ❌", e);
      }




    },
    async listCategoriasCuentas() {

      this.loading = true;
      // recupera cuentas con presupuestos ingresados

      let presupuestos;
      try {
        let data = {
          "centro_id": this.centro_id
        };
        if (this.categoria_id) {
          data.categoria_id = this.categoria_id
        }
        if (this.borrador){
          data["borrador"] = this.borrador
        }
        // solo trae presupuestos > 0
        const response = await api.post("api/v1/presupuestos/centro/", data, {
          headers: {
            "Content-Type": "application/json",

          },
        });

        if (response.status === 200) {

          presupuestos = response.data.presupuestos;

          /*  
          contiene el mismo centro_id
          en todos sus registros

          los cuenta_id no se repiten
           
          "presupuestos": 
          [
               {
                   "id": 5816,
                   "centro_id": 6,
                   "cuenta_id": 8,
                   "empresa_id": 1,
                   "aa": 2025,
                   "moneda_id": 1,
                   "total_presupuesto": "900000.00",
                   "total_gastos": "0.00"
               },
               
             v/s   this.$store.state.cuentas.cuentas
             [{
               "id":112,
               "codigo":"4.5.1030.80.44",
               "nombre":"Alarma",
               "tipo_cuenta":{
               "id":13,
               "nombre":"GTOS BASICOS CASAS E INSTALACIONES",
               "categoria_cuenta":{
                   "id":8,
                   "nombre":"GASTOS GENERALES"
               }
               }
             */

          this.total_presupuesto_centro = presupuestos.reduce(
            (acumulador, item) => {
              return acumulador + Number(item.total_presupuesto)
            }, 0)


          const cuentas = this.$store.state.cuentas.cuentas;
          const { getCatPresup } = useCatPresup()
          this.categoriasCuentas = getCatPresup(presupuestos, cuentas);

          this.date_time = new Date().toISOString()

          this.loading = false;

          /*
       [{
         "id": 1,
         "nombre": "GASTOS DEL PERSONAL",
         "tipos": [
             {
                 "id": 1,
                 "nombre": "GASTOS DEL PERSONAL",
                 "cuentas": [
                     {
                         "id": 5,
                         "cod": "4510301005",
                         "nomcta": "Alimentacion del personal",
                         "total_presupuesto": "4507981.00",
                         "total_gastos": "0.00",
                         "saldo": 4507981
                     },
                     {
                         "id": 6,
                         "cod": "4510301006",
                         "nomcta": "Beneficios al Personal",
                         "total_presupuesto": "900020.00",
                         "total_gastos": "0.00",
                         "saldo": 900020
                     } 
                         
                     
                     
                */


        }

        this.presupuesto_categorias = this.categorias.map(grupo => ({
          nombre: grupo.nombre,
          total_presupuesto: grupo.tipos.flatMap(t => t.cuentas).reduce((acc, c) => acc + Number(c.total_presupuesto), 0)
        }));



      } catch (e) {
        console.error("Credenciales inválidas ❌", e);
      }




    },
    detalle(centro_id, categoria_id) {

      const centros = this.$store.state.centros.centros;
      this.prop_obj_centro = centros.find(cc => cc.id === centro_id) || {};
      this.prop_categoria_id = categoria_id;
      this.celda_seleccionada = `${centro_id}-${categoria_id}`
      this.centro_id = centro_id
      this.categoria_id = categoria_id
      const centros_state = this.$store.state.centros.centros
      /*this.$store.state.centros.centros: [
              {
                  "id": 2,
                  "codigo": "PRO048000000000",
                  "nombre": "Infraestructura Conaf Pumalin",
                  "tiene_presupuesto": true,
                  "usuarios": []
              },*/
      this.objCentroSeleccionado = centros_state.find(cc => cc.id === centro_id);
      this.responsable_firstname = this.objCentroSeleccionado?.user?.first_name
      this.responsable_lastname = this.objCentroSeleccionado?.user?.last_name
      this.listCategoriasCuentas();


    },
    toggleCuenta(id) {

      const i = this.cuentaExpandida.indexOf(id);
      if (i === -1) {

        this.cuentaExpandida.push(id);
        this.$store.dispatch("cuentaUpdVisible", { id: id, centro: this.centro_id, visible: true });
        // store showCta
      } else {
        //console.log(i)
        this.cuentaExpandida.splice(i, 1);
        this.$store.dispatch("cuentaUpdVisible", { id: id, centro: this.centro_id, visible: false });
      }
    },
    resetFiltros() {
      this.selectedCategoria = 0
      this.selectedCentro = 0
      this.selectedClasificacionCentro = 0
      this.selectedCuenta = 0
      this.selectedTipo = 0

    },
    abreModal() {

      /**
       * 
        this.centros_responsables=[
        {
                "id": 63,
                "codigo": "VCO060000000000",
                "nombre": "Comunidades Magallanes",
                "tiene_presupuesto": true,
                "clasificacioncentro_id": 2,
                "presup_ctas":[
                {
                    "categoria_id":1,
                    "centro_id":63,
                    "total_presupuesto":0,
                    "total_gastos":77519
                },
                  
              ]

          },      
          {
              "id": 63,
                "codigo": "VCO060000000000",
                "nombre": "Comunidades Magallanes",
                "tiene_presupuesto": true,
                "clasificacioncentro_id": 2,
                "presup_ctas":[
                {
                    "categoria_id":1,
                    "centro_id":63,
                    "total_presupuesto":0,
                    "total_gastos":77519
                },
          }
        ]
       */
      if (this.selectedUserId > 0) {
        // filtra solo usuario seleccionado
        this.solo_centro_responsable_cuentas = this.responsables_y_cuentas.filter(responsable => responsable.user.id === this.selectedUserId)
      } else {
        this.solo_centro_responsable_cuentas = this.responsables_y_cuentas
      }



      // filtrar territorio: clasificacioncentro_id
      if (this.selectedClasificacionCentro > 0) {
        this.solo_centro_responsable_cuentas = this.solo_centro_responsable_cuentas.filter(centro => centro.clasificacioncentro_id == this.selectedClasificacionCentro)
      }
      // filtrar centro de costo: id
      if (this.selectedCentro > 0) {
        this.solo_centro_responsable_cuentas = this.solo_centro_responsable_cuentas.filter(centro => centro.id == this.selectedCentro)
      }
      if (this.selectedCategoria > 0) {
        this.solo_centro_responsable_cuentas =
          this.solo_centro_responsable_cuentas
            .map(centro => ({
              ...centro,
              presup_ctas: centro.presup_ctas.filter(
                p => p.categoria_id === this.selectedCategoria
              )
            }))
            .filter(centro => centro.presup_ctas.length > 0);
      }
      // filtrar tipo:  

      // filtrar cuenta
      if (this.selectedCuenta > 0) {
        // si seleccionaste cuenta, que solo se muestre la categoria relacionada.
        this.selectedCategoria = this.$store.state.cuentas.cuentas.find(
          cuenta => cuenta.id === this.selectedCuenta
        )?.tipo_cuenta?.categoria_cuenta?.id;

        this.solo_centro_responsable_cuentas =
          this.solo_centro_responsable_cuentas
            .map(centro => ({
              ...centro,
              presup_ctas: centro.presup_ctas.filter(
                p => p.categoria_id === this.selectedCategoria
              )
            }))
            .filter(centro => centro.presup_ctas.length > 0);

      }

      this.visibleModal = true
    },
    creaClasificacionesUnicas(responsables_y_cuentas) {

      const mapaUsuarios = new Map();

      responsables_y_cuentas.forEach(item => {

        let usuarios = [];

        // user puede ser objeto o array
        if (item.user) {
          usuarios = usuarios.concat(
            Array.isArray(item.user)
              ? item.user
              : [item.user]
          );
        }



        usuarios.forEach(usuario => {

          if (!mapaUsuarios.has(usuario.id)) {
            mapaUsuarios.set(usuario.id, {
              user_id: usuario.id,
              clasificacioncentro_id: []
            });
          }

          const registro = mapaUsuarios.get(usuario.id);

          if (
            !registro.clasificacioncentro_id.includes(
              item.clasificacioncentro_id
            )
          ) {
            registro.clasificacioncentro_id.push(
              item.clasificacioncentro_id
            );
          }
        });
      });

      const resultado = Array.from(mapaUsuarios.values());


      return resultado
    },
    openModalDet(categoria_id, nomcat) {
      
      this.det = this.array_detalle_centros_año_actual.find(det => det.categoria_id === categoria_id)
 
 
        
      const centros=this.$store.state.centros.centros
      const centro_y_prespuesto=this.det.centros


        // 1) Recorrer array 'centro_y_presupuesto'
      centro_y_prespuesto.forEach(item => {
            // 2) Buscar si el centro_id existe en el array centros
            const centroEncontrado = centros.find(centro => centro.id === item.centro_id);
            
            // 3) Si existe, extraer y agregar los campos al objeto
            if (centroEncontrado) {
                item.clasificacioncentro_id = centroEncontrado.clasificacioncentro_id;
                item.codigo = centroEncontrado.codigo;
                item.nombre = centroEncontrado.nombre;
            }
        });

        // 4) Ordenar objetos en centro_y_presupuesto
        // Primer criterio: clasificacioncentro_id (ascendente)
        // Segundo criterio: nombre (ascendente)
      centro_y_prespuesto.sort((a, b) => {
            // Primero ordenar por clasificacioncentro_id
            if (a.clasificacioncentro_id !== b.clasificacioncentro_id) {
                return a.clasificacioncentro_id - b.clasificacioncentro_id;
            }
            // Si son iguales, ordenar por nombre
            return a.nombre.localeCompare(b.nombre);
        });


      this.det.centros=centro_y_prespuesto
 

      this.titulo_modal = this.borrador ? `${nomcat} ${ this.$store.state.auth.userLogin.año_borrador}` :  `${nomcat} ${ this.$store.state.auth.userLogin.año}`

      this.showModalDet = true
    }
  },
  data() {
    return {
      array_detalle_centros_año_actual: [],
      colapsado1: true,
      colapsado2: true,
      colapsado3: true,
      colapsado4: true,
      centros: [],
      array_presupuesto_categorias: [],
      loading: false,
      loading2: false,
      presup_ctas: [],
      gastos_ctas: [],
      prop_obj_centro: false,
      prop_categoria_id: 0,
      solo_lectura: true,
      celda_seleccionada: '',
      categorias: {},
      categoriasCuentas: {},
      centro_id: 0,
      categoria_id: 0,
      superUser: false,
      user_id: 0,
      objCentroSeleccionado: {},
      responsable_firstname: '',
      responsable_lastname: '',
      cuentaExpandida: [],
      colores: [

        "#dbfff7", // MARINE PROGRAM
        "#bfe5ff", // CAPE FROWARD NATIONAL PARK
        "#ffdbde", // CERRO CASTILLO NATIONAL PARK
        "#fcffe0", // PATAGONIA NATIONAL PARK
        "#aaffc8", // PUMALÍN DOUGLAS TOMPKINS NATIONAL PARK
        "#fff69e", //RUTA DE LOS PARQUES
        "#efc4fc", // GENERAL SUPPORT

      ],
      leyenda: [

        "Marine Program",
        "Cape Froward National Park",
        "Cerro Castillo National Park",
        "Patagonia National Park",
        "Pumalín Douglas Tompkins National Park",
        "Ruta de los Parques",
        "General Support"
      ],
      users_unicos: [],
      responsables_y_cuentas: [],
      solo_centro_responsable_cuentas: [],
      selectedUserId: 0,
      selectedMes: new Date().getMonth() + 1,
      loading_responsables: false,
      visibleModal: false,
      año: '',
      nombreclasificacion: JSON.parse(process.env.VUE_APP_CLASIF_CENTRO),
      userEsCeciliaBrahm: false,
      selectedClasificacionCentro: 0,
      selectedCentro: 0,
      selectedCategoria: 0,
      selectedTipo: 0,
      selectedCuenta: 0,
      showModalDet: false,
      array_presupuesto_categorias_año_actual: [],
      aa_consulta:0
    }


  }
}
</script>